import PollEditor from './poll-editor'

export type { PollEditorProps } from './poll-editor'

export default PollEditor
